import { downloadAxiosResponse } from '@cibo/ui'
import { AxiosError } from 'axios'
import { useState } from 'react'

import { AgreementsAPI } from '../api'
import { AgreementModel } from '../models'

export const useDownloadAgreement = (
  onError?: (err: AxiosError) => void,
  onComplete?: () => void
) => {
  const [downloading, setDownloading] = useState(false)
  const openFile = (agreement?: AgreementModel) => (event?: any) => {
    event?.stopPropagation && event.stopPropagation()
    if (agreement) {
      setDownloading(true)
      AgreementsAPI.getAgreementFile(agreement.agreementId)
        .then(downloadAxiosResponse(agreement.fileName))
        .catch(onError)
        .finally(() => {
          onComplete && onComplete()
          setDownloading(false)
        })
    }
  }
  return { openFile, downloading }
}
